import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import img_1 from "../../assets/collectionLogo2.png";
import img_2 from "../../assets/collectionLogo1.png";
import img_3 from "../../assets/collectionLogo3.png";

import card1 from "../../assets/images/home/home_opula.jpg";
import card2 from "../../assets/images/home/home_organiq.jpg";
import card3 from "../../assets/images/home/home_eloris.jpg";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./Carousel.css";

import { EffectCreative } from "swiper/modules";
import { Link } from "react-router-dom";

const projects = [
  { desc: "Smart hybrid,consciously made", img: card2, logo: img_1 },
  { desc: "Smart hybrid,consciously made", img: card1, logo: img_2 },
  { desc: "Smart hybrid,consciously made", img: card3, logo: img_3 },
];

const ProjectCarousel = () => {
  const [active, setActive] = useState(0);
  const [isInView, setIsInView] = useState(false);

  const carouselRef = useRef(null);

  // Detect when carousel enters viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { threshold: 0.3 },
    );

    if (carouselRef.current) {
      observer.observe(carouselRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const go = (step) => {
    setActive((prev) =>
      Math.min(Math.max(prev + step, 0), projects.length - 1),
    );
  };

  const swiperRef = useRef(null);
  return (
    <section
      ref={carouselRef}
      className="carousel-section flex items-center flex-col bg-[#fdf9ed]"
    >
      <div className="max-w-full md:max-w-[80%] xl:max-w-[80rem] 3xl:max-w-[90rem] mx-auto w-full">
        {/* DESKTOP SLIDER */}
        <div className="slider w-full md:flex hidden gap-4 overflow-hidden">
          {projects.map((project, idx) => {
            const isActive = active === idx;
            const canReveal = isActive && isInView;

            return (
              <motion.article
                key={idx}
                onMouseEnter={() => setActive(idx)}
                onClick={() => setActive(idx)}
                animate={{ flex: isActive ? 6 : 1.2 }}
                transition={{
                  duration: 0.6,
                  ease: [0.25, 0.46, 0.45, 0.94],
                }}
                className="relative cursor-pointer overflow-hidden shadow-lg flex-shrink-0 h-[300px] sm:h-[400px] md:h-[400px] xl:h-[600px]"
              >
                <motion.img
                  src={project.img}
                  alt="bg"
                  className="absolute inset-0 w-full h-full object-cover"
                  animate={{ scale: isActive ? 1.05 : 1 }}
                  transition={{ duration: 0.6 }}
                />

                {/* TEXT WITH DELAY */}
                <motion.div
                  className="absolute bottom-0 right-0 z-20 flex flex-col p-8 xl:px-20 xl:pt-20 xl:pb-10 justify-center items-start bg-[#fdf9ed]"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{
                    opacity: canReveal ? 1 : 0,
                    y: canReveal ? 0 : 50,
                    scale: canReveal ? 1 : 0.8,
                  }}
                  transition={{
                    duration: 0.5,
                    delay: canReveal ? 1.5 : 0,
                  }}
                >
                  <p className="text-xl sm:text-xl xl:text-3xl font-extralight font-lexend tracking-wide">
                    {project.desc.split(",")[0]},
                  </p>
                  <p className="text-xl sm:text-xl xl:text-3xl font-lexend font-extralight tracking-wide">
                    {project.desc.split(",")[1]}
                  </p>

                  {/* BUTTON */}
                  <motion.button
                    className="relative px-4 lg:px-6 py-2 lg:py-3 lg:mt-4 mt-2 w-32 xl:w-48 xl:text-[22px] sm:text-xl font-normal font-lexend shadow tracking-wider bg-transparent border-2 border-[#3b6840] text-[#3b6840]"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{
                      opacity: canReveal ? 1 : 0,
                      y: canReveal ? 0 : 30,
                    }}
                    transition={{
                      duration: 0.5,
                      delay: canReveal ? 2.3 : 0,
                    }}
                  >
                    <Link to="/shop">EXPLORE</Link>
                  </motion.button>
                </motion.div>

                {/* LOGO */}
                <motion.div
                  className="absolute bottom-0 left-0"
                  animate={{
                    opacity: 1,
                    scale: 1,
                  }}
                  transition={{ duration: 0.5 }}
                >
                  <img
                    src={project.logo}
                    alt="logo"
                    className={`transition-all duration-500 ${
                      isActive ? "w-[60%] lg:w-full" : "w-full"
                    }`}
                  />
                </motion.div>
              </motion.article>
            );
          })}
        </div>

        {/* MOBILE SLIDER */}
        <div className="slider w-[85%] md:w-11/12 mx-auto flex md:hidden overflow-hidden">
          <>
            {/* <motion.article
                  key={idx}
                  onClick={() => setActive(idx)}
                  animate={{ flex: isActive ? 12 : 0 }}
                  transition={{
                    duration: 0.6,
                    ease: [0.25, 0.46, 0.45, 0.94],
                  }}
                  className="relative cursor-pointer overflow-hidden shadow-lg flex-shrink-0 xs:h-[315px] sm:w-[255px] w-full h-[400px]"
                >
                  <motion.img
                    src={project.img}
                    alt="bg"
                    className=" w-full h-full object-cover"
                  />
                  <motion.div
                    className="absolute bottom-0 right-0 z-20 flex w-full flex-col justify-center items-start"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{
                      opacity: canReveal ? 1 : 0,
                      y: canReveal ? 0 : 50,
                      scale: canReveal ? 1 : 0.8,
                    }}
                    transition={{
                      duration: 0.5,
                      delay: canReveal ? 2 : 0,
                    }}
                  >
                    <img
                      src={project.logo}
                      className="w-[220px] h-[95px]"
                      alt="logo"
                    />
                  </motion.div>
                  <div className="z-20 bg-red-500 w-full">
                    <motion.p
                      initial={{ opacity: 0, y: 50 }}
                      animate={{
                        opacity: canReveal ? 1 : 0,
                        y: canReveal ? 0 : 50,
                      }}
                      transition={{
                        duration: 0.5,
                        delay: canReveal ? 2.2 : 0,
                      }}
                      className="text-xl sm:text-xl xl:text-3xl font-extralight font-lexend tracking-wide py-5"
                    >
                      {project.desc}
                    </motion.p>

                    <motion.button
                      className="z-20   px-4 lg:px-6 py-2 lg:py-3 mt-2 w-32 xl:w-48 xl:text-[22px] sm:text-xl font-normal font-lexend shadow tracking-wider border-2 border-[#3b6840] text-[#3b6840]"
                      initial={{ opacity: 0, y: 30 }}
                      animate={{
                        opacity: canReveal ? 1 : 0,
                        y: canReveal ? 0 : 30,
                      }}
                      transition={{
                        duration: 0.5,
                        delay: canReveal ? 2.4 : 0,
                      }}
                    >
                      EXPLORE
                    </motion.button>
                  </div>
                </motion.article> */}

            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setActive(swiper.activeIndex)}
              grabCursor={true}
              effect={"creative"}
              creativeEffect={{
                prev: {
                  shadow: false,
                  translate: [0, 0, -400],
                },
                next: {
                  translate: ["100%", 0, 0],
                },
              }}
              modules={[EffectCreative]}
            >
              <SwiperSlide className="w-full flex flex-col ">
                <div className="relative  sm:h-[315px] w-full h-[400px]">
                  <img
                    src={card2}
                    alt=""
                    className=" object-fill w-full h-full"
                  />
                  <div className="absolute bottom-0">
                    <img src={img_2} className="sm:w-[180px]" alt="" />
                  </div>
                </div>
                <div className="z-30  w-full bg-[#fdf9ed] text-left">
                  <p className="text-xl sm:text-base sm:w-4/5 sm:pe-8  font-extralight font-lexend tracking-wide py-5">
                    Smart hybrid, consciously made
                  </p>

                  <button
                    className="z-20 sm:px-2 px-3 sm:py-1 py-2 sm:w-[115px] w-32  sm:text-[15px] text-[18px] font-normal font-lexend shadow tracking-wider border-2 border-[#3b6840] text-[#3b6840]"
                    initial={{ opacity: 0, y: 30 }}
                  >
                    READ UP
                  </button>
                </div>
              </SwiperSlide>
              <SwiperSlide className="w-full flex flex-col">
                <div className="relative sm:h-[315px]  w-full h-[400px]">
                  <img
                    src={card1}
                    alt=""
                    className="object-cover w-full h-full "
                  />
                  <div className="absolute bottom-0">
                    <img src={img_1} className="sm:w-[180px]" alt="" />
                  </div>
                </div>
                <div className="z-30  w-full bg-[#fdf9ed] text-left">
                  <p className="text-xl sm:text-base sm:w-4/5 sm:pe-8  font-extralight font-lexend tracking-wide py-5">
                    Smart hybrid, consciously made
                  </p>

                  <button
                    className="z-20 sm:px-2 px-3 sm:py-1 py-2 sm:w-[115px] w-32  sm:text-[15px] text-[18px] font-normal font-lexend shadow tracking-wider border-2 border-[#3b6840] text-[#3b6840]"
                    initial={{ opacity: 0, y: 30 }}
                  >
                    READ UP
                  </button>
                </div>
              </SwiperSlide>
              <SwiperSlide className="w-full flex flex-col">
                <div className="relative sm:h-[315px]  w-full h-[400px]">
                  <img
                    src={card3}
                    alt=""
                    className="object-cover w-full h-full "
                  />
                  <div className="absolute bottom-0">
                    <img src={img_3} className="sm:w-[180px]" alt="" />
                  </div>
                </div>
                <div className="z-30  w-full bg-[#fdf9ed] text-left">
                  <p className="text-xl sm:text-base sm:w-4/5 sm:pe-8  font-extralight font-lexend tracking-wide py-5">
                    Smart hybrid, consciously made
                  </p>

                  <button
                    className="z-20 sm:px-2 px-3 sm:py-1 py-2 sm:w-[115px] w-32  sm:text-[15px] text-[18px] font-normal font-lexend shadow tracking-wider border-2 border-[#3b6840] text-[#3b6840]"
                    initial={{ opacity: 0, y: 30 }}
                  >
                    READ UP
                  </button>
                </div>
              </SwiperSlide>
            </Swiper>
          </>
        </div>
        <div className="flex  w-full px-3 pb-4 justify-between items-center md:hidden">
          <div className="flex-1 h-[2px] bg-[#3b6840] mx-4"></div>

          <div className="flex flex-row justify-center items-center gap-4 text-[#4c7e51] font-extralight">
            <button
              onClick={() => swiperRef.current?.slidePrev()}
              disabled={active === 0}
              className="disabled:opacity-30"
            >
              <KeyboardArrowLeftIcon sx={{ fontSize: 48, fontWeight: "300" }} />
            </button>

            <button
              onClick={() => swiperRef.current?.slideNext()}
              disabled={active === projects.length - 1}
              className="disabled:opacity-30"
            >
              <KeyboardArrowRightIcon
                sx={{ fontSize: 48, fontWeight: "300" }}
              />
            </button>
          </div>
        </div>
      </div>

      {/* ARROWS */}
      <div className="md:flex hidden w-full max-w-[1360px] py-4 justify-between items-center">
        <div className="flex-1 h-[2px] bg-[#3b6840] mx-4"></div>

        <div className="flex flex-row justify-center items-center gap-4 text-[#4c7e51] font-extralight">
          <button
            onClick={() => go(-1)}
            disabled={active === 0}
            className="disabled:opacity-30"
          >
            <KeyboardArrowLeftIcon sx={{ fontSize: 48, fontWeight: "300" }} />
          </button>

          <button
            onClick={() => go(1)}
            disabled={active === projects.length - 1}
            className="disabled:opacity-30"
          >
            <KeyboardArrowRightIcon sx={{ fontSize: 48, fontWeight: "300" }} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProjectCarousel;
